// Custom jQuery for Envy Shopify Theme, Designed and Coded by Nine (http://www.wearenine.com)

// Shopping Cart jQuery popup

$(document).ready(function () {
    $('.show-shopping-cart').click(function (e) {
        $("#minicart").toggle();
    });

    $('.close-shopping-cart').click(function (e) {
        $('#minicart').toggle();
    });
});

// FlexSlider

$(window).load(function() {
    $('.flexslider').flexslider({
		animation: "slide",
		directionNav: true,
		controlNav: false,
		controlsContainer: ".flexslider-container"
  });
});

// Superfish Menu

$(function() {
	$('ul#product-nav').superfish({
		delay: 100,
		animation: {opacity:'show',height:'show'}, 
	    speed: 'fast' 
	});
	$("ul#product-nav li").css({ "overflow":"visible"});
});

$(function() {
	$('ul#central-menu').superfish({
		delay: 100,
		animation: {opacity:'show',height:'show'}, 
	    speed: 'fast' 
	});
	$("ul#central-menu li").css({ "overflow":"visible"});
});

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// Product Teaser Thumbnail Rollover

$(document).ready(function(){
	$('.indiv-product').hover(
		 function() {
			 $('.img_default', $(this)).hide();
			 $('.img_rollover', $(this)).show();
		 },
	 function() {
			 $('.img_default', $(this)).show();
			 $('.img_rollover', $(this)).hide();
		 }
	 );
});

// How It Works

var q=0;
function swapImage(){
if(q==0){
    document.getElementById("hiw-map").setAttribute('src','http://cdn.shopify.com/s/files/1/0111/6142/t/3/assets/hiw-2.jpg');
	q++;
}
else{
	document.getElementById("hiw-map").setAttribute('src','http://cdn.shopify.com/s/files/1/0111/6142/t/3/assets/hiw-1.jpg');
	q--;
}
}

function preload(arrayOfImages) {
    $(arrayOfImages).each(function(){
        $('<img/>')[0].src = this;
        // Alternatively you could use:
        // (new Image()).src = this;
    });
}

// Usage:

preload([
    'http://cdn.shopify.com/s/files/1/0111/6142/t/3/assets/hiw-2.jpg'
]);

// Feedback JS //

        $(document).ready(function() {
    		var feed = $("#feedback"),
				img = feed.children("img"),
				formElems = feed.children("form, h3");
			
			feed.css("display", "block").data("showing", false);
			formElems.hide();
			
			img.click(function() {
				if(feed.data("showing") == true) {
					feed.data("showing", false)
						.animate({
							width: "60px",
							height: "120px",
							padding: "0"
						});
					formElems.fadeOut("normal");
					$(this).attr("src", "http://cdn.shopify.com/s/files/1/0111/6142/t/13/assets/free.png").css("top", "0px");
				} else {
					feed.data("showing", true)
						.animate({
							marginLeft: "0",
							height: "200px",
                            width: "175px",
							padding: "10px"
						});
					formElems.fadeIn("normal");
					$(this).attr("src", "http://cdn.shopify.com/s/files/1/0111/6142/t/13/assets/free-hide.png").css("top", "100px");
				}
			})
		}); //end document ready
